import {
    Box,
    FormHelperText,
    Grid,
    InputLabel,
    Typography,
} from '@mui/material';
import React from 'react';
import FormTextField from '../../../shared/FormTextField';
import { useFormContext } from 'react-hook-form';
import FormCheckbox from '../../../shared/FormCheckbox';
import FormSwitch from '../../../shared/FormSwitch';

const PrivateOfficeForm = ({ type }: { type?: string }) => {
    const { control } = useFormContext();

    return (
        <>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid item xs={12}>
                    <InputLabel htmlFor='assignedName__input' required>
                        Name
                    </InputLabel>
                    <FormTextField
                        id='assignedName__input'
                        name='assignedName'
                        control={control}
                        placeholder=''
                    />
                </Grid>
            </Grid>

            <Grid item xs={12} sx={{ pt: 2 }}>
                <Typography
                    component='h2'
                    variant='h3'
                    color='text.primary'
                    sx={{ mb: 0.25 }}
                >
                    Amenities
                </Typography>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='outletsAndChargers__checkbox'
                        name='outletsAndChargers'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='outletsAndChargers__checkbox'>
                        Outlets and Chargers
                    </InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='tv__checkbox'
                        name='tv'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='tv__checkbox'>TV</InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='transmittingEquipment__checkbox'
                        name='transmittingEquipment'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='transmittingEquipment__checkbox'>
                        Transmitting Equipment
                    </InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='camera__checkbox'
                        name='camera'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='camera__checkbox'>Camera</InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='zoom__checkbox'
                        name='zoom'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='zoom__checkbox'>Zoom</InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='msTeams__checkbox'
                        name='msTeams'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='msTeams__checkbox'>
                        Microsoft Teams
                    </InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='googleMeet__checkbox'
                        name='googleMeet'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='googleMeet__checkbox'>
                        Google Meet
                    </InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='soundSystem__checkbox'
                        name='soundSystem'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='soundSystem__checkbox'>
                        Sound System
                    </InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='microphone__checkbox'
                        name='microphone'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='microphone__checkbox'>
                        Microphone
                    </InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='whiteboard__checkbox'
                        name='whiteboard'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='whiteboard__checkbox'>
                        Whiteboard
                    </InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='printingAndScanning__checkbox'
                        name='printingAndScanning'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='printingAndScanning__checkbox'>
                        Printing and Scanning
                    </InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='monitor__checkbox'
                        name='monitor'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='monitor__checkbox'>Monitor</InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='keyboard__checkbox'
                        name='keyboard'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='keyboard__checkbox'>
                        Keyboard
                    </InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='mouse__checkbox'
                        name='mouse'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='mouse__checkbox'>Mouse</InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='dockingStation__checkbox'
                        name='dockingStation'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='dockingStation__checkbox'>
                        Docking Station
                    </InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='ergonomicChair__checkbox'
                        name='ergonomicChair'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='ergonomicChair__checkbox'>
                        Ergonomic Chair
                    </InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='adjustabledDesk__checkbox'
                        name='adjustabledDesk'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='adjustabledDesk__checkbox'>
                        Adjustable Desk
                    </InputLabel>
                </Grid>
                {type === 'house' && (
                    <Grid
                        item
                        container
                        xs={12}
                        md={6}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                        }}
                    >
                        <FormCheckbox
                            id='bed__checkbox'
                            name='bed'
                            control={control}
                            sx={{ p: 0 }}
                        />
                        <InputLabel htmlFor='bed__checkbox'>Bed</InputLabel>
                    </Grid>
                )}
            </Grid>
            {type === 'house' && (
                <>
                    <Grid container columnSpacing={5} rowSpacing={1}>
                        <Grid
                            item
                            container
                            xs={12}
                            md={6}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                            }}
                        >
                            <FormCheckbox
                                id='closet__checkbox'
                                name='closet'
                                control={control}
                                sx={{ p: 0 }}
                            />
                            <InputLabel htmlFor='closet__checkbox'>
                                Closet
                            </InputLabel>
                        </Grid>
                        <Grid
                            item
                            container
                            xs={12}
                            md={6}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                            }}
                        >
                            <FormCheckbox
                                id='bathroom__checkbox'
                                name='bathroom'
                                control={control}
                                sx={{ p: 0 }}
                            />
                            <InputLabel htmlFor='bathroom__checkbox'>
                                Bathroom
                            </InputLabel>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{ pt: 2 }}>
                        <Typography
                            component='h2'
                            variant='h3'
                            color='text.primary'
                            sx={{ mb: 0.25 }}
                        >
                            Arrangement
                        </Typography>
                    </Grid>
                    <Grid container columnSpacing={5} rowSpacing={1}>
                        <Grid
                            item
                            container
                            xs={12}
                            md={6}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                            }}
                        >
                            <FormCheckbox
                                id='dedicatedDesk__checkbox'
                                name='dedicatedDesk'
                                control={control}
                                sx={{ p: 0 }}
                            />
                            <InputLabel htmlFor='dedicatedDesk__checkbox'>
                                Dedicated Desk
                            </InputLabel>
                        </Grid>
                    </Grid>
                </>
            )}
        </>
    );
};

export default PrivateOfficeForm;
